(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portfolio-klasme-group"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');

    function initReveal(section) {
      var targets = section.querySelectorAll('[data-reveal]');
      if (!targets.length) return;

      if (!('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, i * 60);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      targets.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('[id^="marcas-"]').forEach(initReveal);

    /* O editor de temas do Shopify substitui só o HTML da seção via AJAX
       a cada configuração alterada — este script não roda de novo para o
       markup novo, então sem isto os cards ficariam presos em opacity: 0
       (o observer antigo nunca chega a "ver" os elementos recém-inseridos). */
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[id^="marcas-"]');
      if (section) initReveal(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
